import { Injectable } from '@angular/core';
import { HttpClientService } from '../implementacion/http-client.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { ObjDel } from 'src/app/models/SiicartAdm/ObjDel.model';
import { DatosT } from 'src/app/models/SiicartAdm/DatosT.models';


@Injectable({
    providedIn: 'root'
  })
  export class DatosTService {

    constructor( private http: HttpClientService ) { }

    ObtenerDatosT() {
      return this.http.get(`${environment.apiScar}Modelos/ObtenerDatosTabularesAdm`)
        .pipe(map(response => response));
    }
    AgrModfDatosT(carto: DatosT) {
      return this.http.post(`${environment.apiScar}Modelos/AgregarModificarDatosT`, carto)
        .pipe(map(response => response));
    }

    EliminarDatosT(ids: ObjDel) {
      return this.http.post(`${environment.apiScar}Modelos/EliminarDatosT`, ids)
      .pipe(map(response => response));
    }
  }
